import React, { Component, } from 'react';
import { Table } from "react-bootstrap";

import { ConsultPreguntas } from '../../funciones/SolicitudesFunction';

import BecaPreg from "./BecaPreg";

class BecaEstSocioEc extends Component {
    state = { 
        preg1Select: this.props.preg1Select,
        preg2Select: this.props.preg2Select,
        preg3Select: this.props.preg3Select,
        preg4Select: this.props.preg4Select,
        preg1:[],
        preg2:[],
        preg3:[],
        preg4:[],
    }

    componentDidMount = () => {
        ConsultPreguntas ((resp) => {
            this.setState({
                preg1:resp[0],
                preg2:resp[1],
                preg3:resp[2],
                preg4:resp[3]
            })
        })
    }

    updState = (tipo, valor) => {
        this.setState({
            [tipo]: valor
        }, () => {
            this.props.funcion(tipo, valor, "datosBecaEstSocioEc")
        })
    }

    render() {
        let { preg1Select, preg2Select, preg3Select, preg4Select, preg1, preg2, preg3, preg4 } = this.state;
        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info custom-mt-10">Estudio Socio - Económico</div>
                <div className="text-danger custom-mt-10" style={{fontSize: 11}}><strong>Instrucciones:</strong> Selecciona la opción que mejor describa tu realidad actual (Selecciona una sola opción por pregunta)</div>
                <div className="table-responsive">
                    <Table striped hover bordered style={{marginBottom: "0px !important"}}>
                        <tbody>
                            <tr className="custon-back-color">
                                <td colSpan={3} style={styles} align="center"><strong>1.- ¿Cuál es la ocupación actual del jefe del hogar? *</strong></td>
                            </tr>
                            {preg1.map(option => (
                                <BecaPreg key ={option.id} datos={option} select = {preg1Select}
                                funcion = {(valor) => {this.updState("preg1Select", valor)}}/>
                            ))}
                            <tr className="custon-back-color">
                                <td colSpan={3} style={styles} align="center"><strong>2.- ¿Cuál es el nivel educativo del cónyugue o pareja del jefe del hogar? *</strong></td>
                            </tr>
                            {preg2.map(option => (
                                <BecaPreg key ={option.id} datos={option} select = {preg2Select}
                                funcion = {(valor) => {this.updState("preg2Select", valor)}}/>
                            ))}
                            <tr className="custon-back-color">
                                <td colSpan={3} style={styles} align="center"><strong>3.- ¿Cuál es la principal fuente de ingreso del hogar? *</strong></td>
                            </tr>
                            {preg3.map(option => (
                                <BecaPreg key ={option.id} datos={option} select = {preg3Select}
                                funcion = {(valor) => {this.updState("preg3Select", valor)}}/>
                            ))}
                            <tr className="custon-back-color">
                                <td colSpan={3} style={styles} align="center"><strong>4.- ¿En cuál de las siguientes condiciones de alojamiento se encuentra tu vivienda? *</strong></td>
                            </tr>
                            {preg4.map(option => (
                                <BecaPreg key ={option.id} datos={option} select = {preg4Select}
                                funcion = {(valor) => {this.updState("preg4Select", valor)}}/>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        );
    }
}
 
export default BecaEstSocioEc;


// WEBPACK FOOTER //
// ./src/views/EstSolicitudes/BecaEstSocioEc.jsx